import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import SentimentDissatisfiedRoundedIcon from '@mui/icons-material/SentimentDissatisfiedRounded';
import { useNavigate } from 'react-router-dom';

/**
 * NotFound — 404 page shown when the user navigates to an unknown URL.
 * Replaces the wildcard redirect to "/" with a proper user-friendly page.
 */
const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '80vh',
        gap: 2,
        textAlign: 'center',
        px: 3,
      }}
    >
      <SentimentDissatisfiedRoundedIcon sx={{ fontSize: 80, color: 'text.disabled' }} />
      <Typography variant="h3" fontWeight={800} color="text.primary">
        404
      </Typography>
      <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 400 }}>
        La página que estás buscando no existe o fue movida.
      </Typography>
      <Button
        variant="contained"
        size="large"
        onClick={() => navigate('/')}
        sx={{ mt: 2, borderRadius: 2, px: 4, fontWeight: 600 }}
      >
        Ir al Inicio
      </Button>
    </Box>
  );
};

export default NotFound;
